export default __webpack_public_path__ + "static/media/earn.82622ed4.png";